module.exports = __webpack_public_path__ + "img/SWP_Shield_01.9ef4d944.png";